import type { DriveStep } from 'driver.js';

export const staffOrdersTourId = 'staff:orders';

export const staffOrdersSteps: DriveStep[] = [
  {
    element: '[data-tour="staff:orders-search"]',
    popover: {
      title: 'Поиск',
      description:
        'Поиск по номеру заказа или накладной. Введите часть номера для быстрого поиска.',
    },
  },
  {
    element: '[data-tour="staff:orders-filters"]',
    popover: {
      title: 'Фильтры',
      description:
        'Фильтры по статусу заказа. Отфильтруйте заказы по нужному этапу: ожидает, принят, готов к выдаче.',
    },
  },
  {
    element: '[data-tour="staff:orders-table"]',
    popover: {
      title: 'Таблица заказов',
      description:
        'Таблица заказов вашего пункта выдачи. Кликните на строку, чтобы открыть детали заказа, изменить статус или добавить заметку.',
    },
  },
  {
    element: '[data-tour="staff:help-btn"]',
    popover: {
      title: 'Помощь',
      description:
        'Кнопка помощи — всегда доступна для повторного обучения.',
    },
  },
];
